/* eslint-disable */
import { connectSocket, disconnectSocket } from './socket';
// eslint-disable-next-line import/no-cycle
import { Log } from '../common/util';

/* class Pibo {
  constructor(phyId) {
    this.robot_id = null;
    this.is_alive = false;
    this.p = null;
    PIBO_API.onload();
    this.init(phyId);
  }

  get isAlive() {
    return this.is_alive;
  }

  set isAlive(val) {
    const {
      location: { pathname },
    } = window;
    if (
      this.is_alive !== null &&
      this.is_alive !== val &&
      (pathname === '/' || pathname === '/pibo')
    ) {
      window.location.reload();
    }
    this.is_alive = val;
  }

  get robotId() {
    return this.robot_id;
  }

  set robotId(val) {
    this.robot_id = val;
  }

  get pibo() {
    return this.p;
  }

  set pibo(val) {
    this.p = val;
  }

  addGetAlive() {
    console.log('in addGetAlive');
    PIBO_API.receive('pibo', (data) => {
      console.log('receive pibo', data);
      if (data && 'alive' in data && data.alive) {
        this.isAlive = data.alive;
        return;
      }
      this.isAlive = false;
    });
  }

  init(phyId) {
    if (this.robotId && phyId) {
      this.addGetAlive();
    }
    if (!this.robotId || this.robotId !== phyId) {
      log(`piboInit ${phyId}`, 'piboInit');
      this.robotId = phyId;
      // await requestPermissions();
      // this.addGetAlive();
      if (phyId) {
        PIBO_API.init(phyId);
        this.pibo = PIBO_API;
        console.log('set pibo', this.pibo);
      }
    }
  }

  disconnect() {
    this.isInitialized(false);
    PIBO_API.init(null);
    this.pibo = null;
  }
} */

let P = null;
let PI = null;
let alive = null;
let aliveList = [];

const setAliveList = (data, cb) => {
  const { topic, value } = data;
  if (value && !aliveList.includes(topic)) {
    aliveList.push(topic);
  }
  if (!value) {
    aliveList.filter((item) => item !== value);
  }
  if (cb) cb();
};
export const getAliveList = () => {
  return aliveList;
};

const setAlive = (v, cb) => {
  if (cb && typeof cb === 'function') {
    cb(v);
  }
  alive = v;
};

export const getAlive = () => {
  /* if (!alive) {
    getStatus().then(({ result, data }) => {
      if (result && data) {
        const { alive: status, aliveDiff } = data;
        if (alive !== status && aliveDiff < 10) {
          setAlive(status);
        }
      }
      return alive || false;
    });
  } */
  return alive || false;
};

const checkStatus = () => {
  return getAlive();
};

function decorator(mainFn, preCallFn, msg = '') {
  const status = preCallFn();
  if (status) {
    mainFn();
    return true;
  }
  if (msg) {
    // eslint-disable-next-line no-alert
    alert(msg);
  }
  return false;
}

// eslint-disable-next-line consistent-return
export const piboInit = async (phyId, cb = null, connectCb = null) => {
  const pibo = await connectSocket(phyId);
  if (pibo.pibo === null && cb) {
    return cb();
  }
  if (pibo) {
    P = pibo;
    PI = P.pibo;
    aliveList = [];
    if (PI) {
      const timer = setTimeout(
        () => (alive ? connectCb && connectCb() : cb && cb()),
        2500,
      );
      return PI.receive('pibo', (data, topic) => {
        if (!data.alive && data.data.indexOf('disconn') > -1 && !getAlive()) {
          return setAliveList({ topic, value: false }, () => {
            Log('pibo alive false');
          });
        }
        clearTimeout(timer);
        if (data && 'alive' in data && data.alive) {
          return setAliveList({ topic, value: data.alive }, () => {
            if (connectCb) {
              connectCb();
            }
          });
        }
        // alert(`pibo received data 연결되지 않음 - cb 실행, ${cb}`);
        return setAliveList({ topic, value: false }, cb);
      });
    }
  }
};

export const setPiboLocale = (locale, cb) => {
  if (checkStatus()) {
    PI.onload();
    PI.change(locale, cb);
  }
};

export const speakPibo = (str, cb = null) => {
  const talk = () =>
    PI.talk(str, (d) => {
      if (cb) {
        cb(d);
      }
    });
  return decorator(talk, checkStatus);
};

export const checkPiboCmds = (str, cb) => {
  const candidate = () =>
    PI.candidate(str, (data) => {
      cb(data);
    });
  decorator(candidate, checkStatus);
};

export const sendPiboMsg = ({ mode, type }, cb = null) => {
  // if (checkStatus()) {
  return PI.message({ mode, type }, (data) => {
    if (cb) {
      cb(data);
    }
  });
  // }
  // return cb(false);
};

export const sendSaveStatus = () => {
  PI.send('$_setup', 'ready');
};

export const deletePiboMsg = (_id) => {
  const delmsg = () => PI.send('messageDelete', { _id });
  decorator(delmsg, checkStatus);
};

export const c = (type, cb) => {
  const receive = () =>
    PI.receive(type, (data) => {
      if (typeof cb === 'function') {
        if (data) {
          return cb(data);
        }
        return cb();
      }
    });
  return decorator(receive, checkStatus);
};

export const setPiboMode = (mode, value) => {
  const setmode = () => PI.mode(mode, { value });
  return decorator(setmode, checkStatus);
};

export const actionPibo = (value) => {
  const action = () => PI.motion(value);
  decorator(action, checkStatus);
};

export const killPibo = () => {
  const kill = () => PI.kill();
  decorator(kill, checkStatus);
};

export const motionPibo = (direction, cycle) => {
  const motion = () => PI.motion(direction, { cycle });
  return decorator(motion, checkStatus);
};

export const speakAndMotionPibo = (value) => {
  const sap = () => PI.speak(value);
  return decorator(sap, checkStatus);
};

export const takePicturePibo = (cb) => {
  const cam = () =>
    PI.camera((data) => {
      if (data && 'result' in data && data.result) {
        return cb(data.data);
      }
      return cb(null);
    });
  return decorator(cam, checkStatus);
};

export const simulatePibo = (part, pos) => {
  PI.simulator(part, { pos });
  // const simulator = () => PI.simulator(part, { pos });
  // return decorator(simulator, checkStatus);
};

export const setPiboLocation = (value) => {
  const location = () => P.send('location', value);
  decorator(location, checkStatus);
};

export const setPiboGeo = (value, cb) => {
  if (checkStatus()) {
    return PI.geo(value, () => {
      cb && cb();
    });
  }
  cb && cb();
};

export const setPiboDisturb = (value, cb) => {
  if (checkStatus()) {
    const {
      execTime,
      expTime,
      repeatValue: {
        value: { day },
      },
    } = value;
    PI.mode('disturb', { execTime, expTime, day });
  }
  cb && cb();
};

export const setPiboReaction = (value, cb) => {
  if (checkStatus()) {
    PI.reaction(value);
  }
  cb && cb();
};

let timeout;
export const setPiboVolume = (value) => {
  if (timeout) clearTimeout(timeout);
  timeout = setTimeout(() => {
    const volume = () => PI.volume(value);
    return decorator(volume, checkStatus);
  }, 300);
};

export const complimentPibo = (cb) => {
  const compliment = () => PI.compliment(cb);
  return decorator(compliment, checkStatus);
};

export const getPiboInfo = () =>
  new Promise((res, rej) => {
    PI.info((data) => {
      if (data) {
        setAlive(true);
        return res(data);
      }
      setAlive(false);
      return rej(new Error('unconnected'));
    });
  });

export const setPiboBot = (cmd, data) => {
  const bot = () => PI.bot(cmd, data);
  decorator(bot, checkStatus);
};

export const receivePiboEvent = (type, cb) => {
  const receive = () =>
    PI.receive(type, (data) => {
      if (typeof cb === 'function') {
        if (data) {
          return cb(data);
        }
        return cb();
      }
    });
  // return decorator(receive, checkStatus);
  receive();
};

export const refreshBots = (cb) => {
  const refresh = () => PI.refreshBots(cb);
  decorator(refresh, checkStatus);
};

export const haltPibo = () => {
  const halt = () => PI.halt();
  decorator(halt, checkStatus);
};

export const getWifiList = (cb) => {
  const getList = () => PI.wifi_list(cb);
  decorator(getList, checkStatus);
};

export const getVersion = () => (P && 'version' in P ? P.version : '');

export const wifiReset = (cb) => {
  const reset = () => PI.wifi_reset(cb);
  decorator(reset, checkStatus);
};

export const wifiChange = (ap, cb) => {
  const change = () =>
    PI.wifi_change(ap, (data) => {
      cb();
    });
  decorator(change, checkStatus);
};

export const piboReset = () => {
  const reset = () => PI.reset();
  decorator(reset, checkStatus);
};

export const setGroup = (arr) => {
  if (PI) {
    PI.setGroup(arr);
  }
};

export const callPibo = (v) => {
  if (PI) {
    PI.webrtc(v ? 'on' : 'off');
  }
};

export const piboDisconnect = () => {
  disconnectSocket(null);
  P = null;
  PI = null;
  alive = null;
  aliveList = [];
};
